'use client';
import React from 'react';
import { GlobalStyle } from './GlobalStyles.styled';

interface IGlobalStyles {
  lang: string;            // keep if you want; unused is fine
  children?: React.ReactNode;
}

export const GlobalStyles: React.FC<IGlobalStyles> = ({ children }) => {
  return (
    <>
      <GlobalStyle />
      {children}
    </>
  );
};
